import { createModule } from '../createModule';
import { IAgreement } from '@/models';

export const agreementStatus = createModule<IAgreement>('agreementStatus', {
    url: 'agreement_status',
    actions: {
        pushMessage({ commit }, payload) {
            commit('pushMessage', payload);
        }
    },
    mutations: {
        pushMessage(state, payload) {
            const item = Object.values(state.entities).find(({ id }) => id === payload.id)
            item?.chat?.messages.push(payload.data)
        }
    }
});